import posthog from 'posthog-js'

import { TablelistAnalyticsApp, TablelistPersonType } from 'shared'

import type { Venue } from 'types/model/venue'

let clientInitialized = false

export function ensureBuyLegacyPosthog(): void {
  if (typeof window === 'undefined') return
  if (clientInitialized) return
  if (process.env.NEXT_PUBLIC_ENV === 'local') return

  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY
  if (!key) return

  clientInitialized = true
  const nodeEnv = process.env.NODE_ENV ?? 'development'
  posthog.init(key, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST ?? '',
    ui_host:
      process.env.NEXT_PUBLIC_POSTHOG_UI_HOST ?? 'https://us.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
  })
  const env = process.env.NEXT_PUBLIC_ENV ?? 'dev'
  posthog.register({
    env,
    environment: nodeEnv === 'production' ? 'prod' : 'dev',
    nodeEnv,
    tablelist_app: TablelistAnalyticsApp.BUY_LEGACY,
  })
  posthog.setPersonProperties({
    tablelist_app: TablelistAnalyticsApp.BUY_LEGACY,
  })
}

export function identifyBuyLegacyConsumer(user: {
  id: string
  email?: string | null
  name?: string | null
  firstName?: string | null
  lastName?: string | null
  phone?: string | null
}): void {
  ensureBuyLegacyPosthog()
  if (!clientInitialized) return

  posthog.identify(user.id, {
    tablelist_person_type: TablelistPersonType.CONSUMER,
    tablelist_app: TablelistAnalyticsApp.BUY_LEGACY,
    email: user.email ?? undefined,
    name: user.name ?? undefined,
    firstName: user.firstName ?? undefined,
    lastName: user.lastName ?? undefined,
    phone: user.phone ?? undefined,
  })
  posthog.setPersonProperties({
    tablelist_person_type: TablelistPersonType.CONSUMER,
    tablelist_app: TablelistAnalyticsApp.BUY_LEGACY,
  })
}

export function resetBuyLegacyPosthog(): void {
  if (!clientInitialized) return
  posthog.reset()
}

/** Associates PostHog session with venue (and org) for group analytics / pageview breakdown. */
export function syncBuyLegacyVenueGroup(venue: Venue): void {
  ensureBuyLegacyPosthog()
  if (!clientInitialized) return

  const organizationId = venue.organization
    ? String(venue.organization)
    : undefined
  if (organizationId) {
    posthog.group('organization', organizationId, {
      organizationId,
      name: venue.organizationName,
    })
  }

  const venueId = String(venue.id)
  posthog.group('venue', venueId, {
    venueId,
    name: venue.name,
    slug: venue.slug ?? venue.seoPathname,
    type: venue.type,
    organizationId,
    organizationName: venue.organizationName,
    city: venue.location?.city,
    enable: venue.enable,
    visibility: venue.visibility,
    timezone: venue.location?.timezone,
  })
}
